import { Injectable } from '@angular/core';
declare var jQuery: any;

Injectable()
export class SharedDataService {
    public userInfo: UserInfo;
    public customerId: any;

    constructor() { }

}

interface UserInfo {
    name: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    zipcode: string
}  


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/shared-data.service.ts